import CustomModal from "../CustomModal";
import { useState, useEffect } from "react";


function EditLocationModal({ isOpen, onRequestClose, location, onSave }) {
  const [form, setForm] = useState({ name: "", address: "", phone: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (location) {
      setForm({
        name: location.name || "",
        address: location.address || "",
        phone: location.phone || "",
      });
    }
  }, [location]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onSave(form);
    setSaving(false);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-admin-modal"
      hideFooter={true}
    >
      <div className="form-container">
        <div className="inner-form">
          <div className="add-staff-head">
            <h2>Edit Location</h2>
          </div>
          <div className="form-input">
            <form onSubmit={handleSubmit}>
              <label htmlFor="name">Name</label>
              <input id="name" name="name" value={form.name} onChange={handleChange} required />

              <label htmlFor="address">Address</label>
              <input id="address" name="address" value={form.address} onChange={handleChange} required />

              <label htmlFor="phone">Phone</label>
              <input id="phone" name="phone" value={form.phone} onChange={handleChange} required />

              <div className="modal-button">
                <button type="button" onClick={onRequestClose}>Cancel</button>
                <button type="submit" style={{ backgroundColor: "#0473BD", color: "white" }} disabled={saving}>
                  {saving ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

export default EditLocationModal;
